export default {
  settings: (state) => state.settings,
  isLoading: (state) => state.isLoading,
  isSaving: (state) => state.isSaving,
  hasError: (state) => !!state.error,
  error: (state) => state.error,
};
